// Vue
import Vue from 'vue'

require('@/assets/sass/global.sass')

// Services to help structure
import AuthService from '@/services/auth.js'
import ValidatorsService from '@/services/validators.js'

// App-Structure
import App from './App'
import router from './router'

// Third-party plugins
import Buefy, { Dialog } from 'buefy'
import VueTheMask from 'vue-the-mask'
import VueMoney from 'v-money'
import VueMoment from 'vue-moment'
import VeeValidate, {Validator} from 'vee-validate'
import MessagesPT from 'vee-validate/dist/locale/pt_BR'
import VueI18n from 'vue-i18n'

// Other components
import InternalDialog from './components/dialog'

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'pt_BR'
})

const moment = require('moment')
require('moment/locale/pt-br')
require('vue2-animate/dist/vue2-animate.min.css')

Vue.use(Buefy, {
  defaultNoticeQueue: false,
  defaultDateFormatter: date => date.toLocaleDateString('pt-BR')
})
Vue.use(VueTheMask)
Vue.use(VueMoney, {
  precision: 2,
  decimal: ',',
  thousands: '.',
  prefix: 'R$'
})
Vue.use(VueMoment, {moment})

Object.entries(ValidatorsService).forEach(validator => {
  Validator.extend(validator[0], validator[1])
})

Vue.use(VeeValidate, {
  i18n,
  dictionary: {
    pt_BR: MessagesPT
  },
  delay: 600,
  enableAutoClasses: true,
  classNames: {
    valid: 'is-success',
    invalid: 'is-danger'
  }
})

Vue.prototype.$internalDialog = InternalDialog

Vue.http.interceptors.push((request, next) => {
  const token = AuthService.getToken()
  if (token) {
    request.headers.set('Authorization', 'Bearer ' + token)
  }

  next((response) => {
    if (response.status === 401 && response.body.error === 'token_expired') {
      AuthService.logout()
      .then(response => {
        router.push({ name: 'Auth' })
        Dialog.alert('Seu login expirou, por favor autentique novamente!')
      })
    }

    if (response.status === 403 && response.body.error === 'user_inactive') {
      AuthService.logout()
      .then(response => {
        router.push({ name: 'Auth' })
        Dialog.alert('O seu usário está inativo!')
      })
    }
  })
})

Vue.filter('currency', (value) => {
  if (!value) return null
  return parseFloat(value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
})

Vue.filter('pluralize', (value, text, sufix) => {
  sufix = sufix || 's'
  if (value > 1 || Math.floor(value) === 0) return `${text}${sufix}`
  return text
})

Vue.filter('requirize', (value, field) => {
  if (field.rules && field.rules.required) return `${value}*`
  return value
})

Vue.filter('resourceUrl', (value) => {
  value = value.toString()
  return `${process.env.RESOURCES_URL}${value}`
})

Vue.filter('expenseType', (value) => {
  if (parseInt(value) === 1) return '1 - Investimento'
  if (parseInt(value) === 2) return '2 - Custo'

  return ''
})

Vue.config.productionTip = false
Vue.config.devtools = true

if (process.env.IS_HOM) window.document.title = 'ERP - HOMOLOGAÇÃO | thepes'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js